<nz-space class="mobile-report-control">
  <app-supplier-select #fromSelect [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="code" [activeOnly]="false" [showAddNewButton]="false">
  </app-supplier-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-supplier-select #toSelect [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="code" [activeOnly]="false" [showAddNewButton]="false"></app-supplier-select>
</nz-space>